import * as tslib_1 from "tslib";
import { Subject, BehaviorSubject, forkJoin } from 'rxjs';
import { DomSanitizer, Title } from '@angular/platform-browser';
import * as $ from 'jquery';
import { SnotifyService, SnotifyPosition } from 'ng-snotify';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { StaticDataService } from './static-data.service';
import { Config } from '../config/config';
import { RestDataService } from './rest-data.service';
import { EmbedVideoService } from 'ngx-embed-video';
import { GoogleAnalyticsService } from './google-analytics.service';
import { Router } from '@angular/router';
export class SharedDataService {
    constructor(titleService, snotifyService, http, router, config, restService, embedService, snotify, handler, sanitizer, gaService) {
        this.titleService = titleService;
        this.snotifyService = snotifyService;
        this.http = http;
        this.router = router;
        this.config = config;
        this.restService = restService;
        this.embedService = embedService;
        this.snotify = snotify;
        this.handler = handler;
        this.sanitizer = sanitizer;
        this.gaService = gaService;
        this.domainIdSubject = new Subject();
        this.videoCMSSubject = new Subject();
        this.configLoaded = new Subject();
        this.autoBacklinkSuggestionList = new Subject();
        this.autoMultipleStockUpdates = new Subject();
        this.shareValue = new BehaviorSubject(null);
        this.currentValue = this.shareValue.asObservable();
        this.dragValue = null;
        this.slugValue = new Subject();
        this.style = 'material';
        this.title = 'Snotify title!';
        this.body = 'Lorem ipsum dolor sit amet!';
        this.timeout = 5000;
        this.position = SnotifyPosition.rightTop;
        this.progressBar = false;
        this.closeClick = true;
        this.newTop = false;
        this.filterDuplicates = true;
        this.backdrop = 0;
        this.dockMax = 8;
        this.blockMax = 6;
        this.pauseHover = false;
        this.titleMaxLength = 100;
        this.bodyMaxLength = 200;
        // html = '<div class="harshit"><p>vsbsdbvsdbsb</p></div>';
        this.currentDomainUrl = '';
        this.monthNames = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
        this.dailyTrendsId = {
            category: "DailyTrends",
            id: "64a7ab90bca3a33781ab8253"
        };
        this.allRealTrendsId = {
            category: "All",
            id: "64a7ab8abca3a33781ab8251"
        };
        this.subject = new Subject();
        this.httpClient2 = new HttpClient(handler);
    }
    sendData(message) {
        // if (message.indexOf('publish_disable|') < 0) {
        // console.log('%c-----\n' + 'internal_socket -> ' + message + '\n-----', 'color: black; font-size: 15px; font-weight: bold;');
        // }
        this.subject.next(message);
    }
    getRecommendedAutobacklinkContentMap() {
        return this.recommendedAutobacklinkContentMap;
    }
    setRecommendedAutobacklinkContentMap(data) {
        this.recommendedAutobacklinkContentMap = data;
    }
    overflowhidden() {
        $('body').css('overflow', 'hidden');
    }
    overflowauto() {
        $('body').css('overflow', 'auto');
    }
    clearData() {
        this.subject.next();
    }
    getData() {
        return this.subject.asObservable();
    }
    setTitle(newTitle) {
        if (newTitle) {
            this.titleService.setTitle(newTitle.trim());
        }
    }
    setValue(video) {
        this.shareValue.next(video);
    }
    checkUrl(url) {
        if (url.charAt(0) !== '/' && url.substring(0, 4) !== 'http') {
            return true;
        }
        return false;
    }
    getConfig(ev) {
        this.snotifyService.setDefaults({
            global: {
                newOnTop: this.newTop,
                maxAtPosition: this.blockMax,
                maxOnScreen: this.dockMax,
            }
        });
        if (typeof ev === 'boolean') {
            if (ev === true) {
                return {
                    bodyMaxLength: this.bodyMaxLength,
                    titleMaxLength: this.titleMaxLength,
                    backdrop: this.backdrop,
                    position: this.position,
                    timeout: this.timeout,
                    showProgressBar: this.progressBar,
                    closeOnClick: this.closeClick,
                    pauseOnHover: this.pauseHover,
                    html: null
                };
            }
            else if (ev === false) {
                return {
                    bodyMaxLength: this.bodyMaxLength,
                    titleMaxLength: this.titleMaxLength,
                    // backdrop: this.backdrop,
                    position: this.position,
                    timeout: this.timeout,
                    showProgressBar: this.progressBar,
                    closeOnClick: this.closeClick,
                    pauseOnHover: this.pauseHover,
                    html: null
                };
            }
        }
        else if (ev === 'lock') {
            return {
                bodyMaxLength: this.bodyMaxLength,
                titleMaxLength: this.titleMaxLength,
                // backdrop: this.backdrop,
                position: this.position,
                timeout: this.timeout,
                showProgressBar: this.progressBar,
                closeOnClick: this.closeClick,
                pauseOnHover: this.pauseHover,
                html: null
            };
        }
    }
    getImageOnPriority(obj, model_id) {
        if (obj && obj !== null) {
            let allKEYS = Object.keys(obj);
            allKEYS = allKEYS.filter(e => (e.indexOf('x') > -1));
            const key = allKEYS.map(e => (Number(e.split('x')[0])));
            const modelSplit = model_id.split('x');
            const first = (modelSplit && modelSplit.length > 0) ? Number(modelSplit[0]) : null;
            const last = (modelSplit && modelSplit.length > 1) ? Number(modelSplit[1]) : null;
            if (model_id && model_id !== null && model_id !== '' && model_id !== 'original') {
                if (obj.hasOwnProperty(model_id) && obj[model_id] !== null && obj[model_id] !== '') {
                    return obj[model_id];
                }
                else {
                    if (obj.hasOwnProperty('original') && obj['original'] !== null && obj['original'] !== '') {
                        return obj['original'];
                    }
                    else {
                        if (first !== null) {
                            return this.getLastIndex(obj, key.filter(e => (e !== Number(first))), allKEYS);
                        }
                        else {
                            return this.getLastIndex(obj, key, allKEYS);
                        }
                    }
                }
            }
            else {
                if (obj.hasOwnProperty('original') && obj['original'] !== null && obj['original'] !== '') {
                    return obj['original'];
                }
                else {
                    return this.getLastIndex(obj, key, allKEYS);
                }
            }
        }
        else {
            return null;
        }
    }
    getLastIndex(obj, arr, all) {
        if (obj && obj !== null && arr && arr.length > 0) {
            const max = Math.max.apply(null, arr);
            const key = all.filter(e => (e.indexOf(String(max) + 'x') > -1));
            if (obj[key] !== null && obj[key] !== '') {
                return obj[key];
            }
            else {
                return this.getLastIndex(obj, arr.filter(e => (e !== max)), all);
            }
        }
        else {
            return null;
        }
    }
    checkEmbed(embed) {
        // console.log(embed);
        if (embed.indexOf('src="//players.brightcove.net') > -1) {
            return embed.replace('src="', 'src="https:');
        }
        else if (embed.indexOf('src=\'//players.brightcove.net') > -1) {
            return embed.replace('src=\'', 'src=\'https:');
        }
        else {
            if (this.isEmbedStripEnabled() && embed.indexOf('cdn.jwplayer.com') > -1) {
                // if (embed.indexOf('src="') > -1) {
                //     const url = embed.split('iframe src="')[1].split('"')[0];
                //     return ('<iframe src="' + url + '"></iframe>');
                //   } else if (embed.indexOf('src=\'') > -1) {
                //     const url = embed.split('iframe src=\'')[1].split('\'')[0];
                //     return ('<iframe src="' + url + '"></iframe>');
                //   } else {
                //       return embed;
                //   }
                return embed.replace(new RegExp('style="[^"]*"', 'g'), '')
                    .replace(new RegExp('style=\'[^\']*\'', 'g'), '');
            }
            else {
                return embed;
            }
        }
    }
    getImage(imageUrl) {
        return this.http.get(imageUrl, { responseType: 'blob' });
    }
    sendVideoData(url, requestBody, setStatusBody) {
        this.http.post(url, requestBody).subscribe(res => {
            console.log("video res");
            console.log(res);
        }, error => {
            this.http.post(this.config.get('product').videoCmsUrl + "/api/cms/video/revertStatus", setStatusBody).subscribe(revert => {
                if (revert != null) {
                    console.log("reverted successfully");
                }
            });
        });
    }
    retryVideoData(url, requestBody, setStatusBody) {
        this.http.put(url, requestBody).subscribe(res => {
            console.log("video res");
            console.log(res);
        }, error => {
            this.http.post(this.config.get('product').videoCmsUrl + "/api/cms/video/revertStatus", setStatusBody).subscribe(revert => {
                if (revert != null) {
                    console.log("reverted successfully");
                }
            });
        });
    }
    createObjectFromImageUrl(imageUrl, callback) {
        // console.log(this.getImage(imageUrl));
        this.getImage(imageUrl).subscribe(e => {
            // console.log(e);
            const reader = new FileReader();
            // console.log('file uplaod called');
            const fd = new FormData();
            // console.log(this.SingleselectedFile);
            // this.showLoader = true;
            const a = reader.readAsDataURL(e);
            reader.onload = (e4) => {
                callback({
                    url: imageUrl,
                    data: e4.target.result
                }, reader);
            };
        }, err => {
            callback(false);
        });
    }
    getDifference(a, b) {
        let i = 0;
        let j = 0;
        let result = '';
        while (j < b.length) {
            if (a[i] !== b[j] || i === a.length) {
                result += b[j];
            }
            else {
                i++;
            }
            j++;
        }
        return result;
    }
    checkImageForAMP(reader, callback) {
        let img = new Image;
        img.onload = function () {
            callback((+(img.width) >= 1200) && (+(img.height) >= 900));
        };
        img['src'] = reader.result;
    }
    showAMPConfirmPopup(yesCallback, noCallback) {
        if (this.isdomainConfig('story', 'dontshowSEOMessage')) {
            yesCallback();
        }
        else {
            const _a = this.getConfig(true), { timeout, closeOnClick } = _a, config = tslib_1.__rest(_a, ["timeout", "closeOnClick"]);
            this.snotifyService.confirm('The image size is less than 1200x900 mandated by SEO. Do you still want to proceed?', '', Object.assign({}, config, { buttons: [
                    {
                        text: 'Yes', action: (toast) => {
                            yesCallback();
                            this.snotifyService.remove(toast.id);
                            this.googleAnalytics("Skippable Alerts", 'The image size is less than 1200x900 mandated by SEO. Do you still want to proceed?', sessionStorage.getItem(StaticDataService.tenantName) + ' ' + 'Yes', null);
                        }, bold: false
                    },
                    {
                        text: 'No', action: (toast) => {
                            noCallback();
                            this.snotifyService.remove(toast.id);
                            this.googleAnalytics("Skippable Alerts", 'The image size is less than 1200x900 mandated by SEO. Do you still want to proceed?', sessionStorage.getItem(StaticDataService.tenantName) + ' ' + 'No', null);
                        }
                    }
                ] }));
        }
    }
    analyticsCall(url, id, classes, target) {
        if (url && id && target) {
            window['dapCollector']('trackLinkClick', url.trim(), id.trim().replace(' ', '-').toLowerCase(), (classes ? classes : []), target.trim().toLowerCase());
        }
    }
    setDomain() {
        const token = localStorage.getItem(StaticDataService.tokenLiteral);
        const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
        if (token && domain) {
            const url = this.config.get('product').domainUrl
                + this.config.getEndPoint(this.config.get('views'), 'all_related_stories', StaticDataService.related_domain_mapping);
            this.restService.http_get(url)
                .subscribe(data => {
                localStorage.setItem(StaticDataService.allDomains, JSON.stringify(data));
                var domainUrlMap = {};
                for (const item of data) {
                    domainUrlMap[item.id] = item.baseUrl;
                    if (item.id === domain) {
                        this.currentDomainUrl = item.baseUrl;
                    }
                }
                localStorage.setItem(StaticDataService.allDomainsUrlMap, JSON.stringify(domainUrlMap));
            });
        }
        // if (token && domain) {
        //     const url = this.config.get('product').domainUrl
        //         + this.config.getEndPoint(this.config.get('views'), 'all_related_stories_embed', StaticDataService.related_domain_mapping_embed);
        //     this.restService.http_get(url)
        //         .subscribe(data => {
        //           localStorage.setItem(StaticDataService.allDomains,  JSON.stringify(data));
        //             for (const item of data) {
        //                 if (item.id === domain) {
        //                     this.currentDomainUrl = item.baseUrl;
        //                 }
        //             }
        //         });
        // }
    }
    //   getAllDomains() {
    //     const token = localStorage.getItem(StaticDataService.tokenLiteral);
    //     const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
    //     if (token && domain) {
    //         const url = this.config.get('product').domainUrl
    //             + this.config.getEndPoint(this.config.get('views'), 'all_related_stories', StaticDataService.related_domain_mapping);
    //         this.restService.http_get(url)
    //             .subscribe(data => {
    //             });
    //     }
    // }
    setConfig() {
        const token = localStorage.getItem(StaticDataService.tokenLiteral);
        const currentDomainUrl = sessionStorage.getItem(StaticDataService.domainLiteral);
        if (token && currentDomainUrl) {
            const url = this.config.get('product').baseUrl + '/api/cms/admin/config/all';
            this.restService.http_get(url)
                .subscribe(data => {
                let conf = {};
                for (const item of data) {
                    conf[item.domainId] = item;
                }
                setTimeout(e => {
                    localStorage.setItem(StaticDataService.configTimeLiteral, String(new Date().getTime()));
                    localStorage.setItem(StaticDataService.domainsConfigLiteral, JSON.stringify(conf));
                    if (conf && currentDomainUrl) {
                        this.currentDomainConfiguration = conf[currentDomainUrl];
                        this.configLoaded.next(true);
                    }
                    else {
                        this.currentDomainConfiguration = StaticDataService.defaultConfig;
                    }
                }, 1);
            });
        }
        else {
            const conf = localStorage.getItem(StaticDataService.domainsConfigLiteral);
            const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
            if (conf && domain) {
                this.currentDomainConfiguration = JSON.parse(conf)[domain];
            }
            else {
                this.currentDomainConfiguration = StaticDataService.defaultConfig;
            }
        }
    }
    checkAndGetEmbed(text, callback) {
        if (text.indexOf('>') > -1 || text.indexOf('<') > -1) {
            callback(text);
        }
        else {
            try {
                text = this.removeyoutubeparamsName(text);
                const embed = this.embedService.embed(text);
                if (embed && embed !== null && embed !== '') {
                    callback(embed['changingThisBreaksApplicationSecurity']);
                }
                else {
                    this.checkIfThirdPartyEmbed(text, callback);
                }
            }
            catch (e) {
                this.checkIfThirdPartyEmbed(text, callback);
            }
        }
    }
    removeyoutubeparamsName(text) {
        if ((text.indexOf('&t') > -1) || (text.indexOf('&ab_channel') > -1) || (text.indexOf('&start_radio') > -1) || (text.indexOf('&list') > -1)) {
            text = text.substring(0, text.indexOf('&'));
            console.log(text);
        }
        return text;
    }
    checkIfThirdPartyEmbed(text, callback) {
        if (text.indexOf('https://twitter.com') > -1 || text.indexOf('https://www.instagram.com') > -1) {
            this.getAutomaticEmbed(text).subscribe(data => {
                // return data;
                callback(this.escToText(data.html));
            }, error => {
                // return error;
                this.snotify.error('API failed (please check the url)', '', this.getConfig(false));
                callback(text);
            });
        }
        else {
            callback(text);
        }
    }
    croppingSequence(cropRequests, differentLeadFlag, callback) {
        forkJoin(cropRequests)
            .subscribe(result => {
            let imagemap = {};
            let ampFlag = false;
            this.snotify.clear();
            this.snotify.success('Cropped successfully', '', this.getConfig(false));
            result.filter(e => e).forEach(el => {
                let images = el['images'];
                if (el.hasOwnProperty('ampValidated') && el['ampValidated']) {
                    ampFlag = true;
                }
                if (images.hasOwnProperty('1600x900')) {
                    imagemap['ampImage'] = images['1600x900'];
                }
                if (differentLeadFlag && (images.hasOwnProperty('250x250') || images.hasOwnProperty('90x90'))) {
                    images['original2'] = images['original'];
                    delete images['original'];
                    imagemap = Object.assign(imagemap, images);
                }
                else {
                    imagemap = Object.assign(imagemap, images);
                }
            });
            setTimeout(e => {
                callback({
                    ampFlag,
                    imagemap
                });
            }, 10);
        }, err => {
            this.snotify.clear();
            this.snotify.info('Cropping Failed', '', this.getConfig(false));
            callback({
                error: err
            });
        });
    }
    // text2HTML(inputText) {
    //     let text = inputText.replace(/&/g, '&amp;')
    //       .replace(/</g, '&lt;')
    //       .replace(/>/g, '&gt;');
    //     text = text.replace(/\r\n?|\n/g, '<br>');
    //     text = text.replace(/<br ?\/?>/g, '</p><p>');
    //     text = '<p>' + text + '</p>';
    //     return text;
    // }
    checkhrefandreplace(jso) {
        const st = JSON.stringify(jso);
        const arr = st.split('href=\\"');
        arr.forEach((val, index) => {
            if (index > 0) {
                if (!val.startsWith('http')) {
                    arr[index] = 'http://' + val;
                }
            }
        });
        const newst = arr.join('href=\\"');
        return this.checkAndAddNoFollowTag(JSON.parse(newst));
    }
    checkAndAddNoFollowTag(jso) {
        if (jso !== undefined && (jso.type === 'paragraph' || jso.type === 'liveblog') && this.currentDomainConfiguration && this.currentDomainConfiguration['config']
            && this.currentDomainConfiguration['config']['story']
            && this.currentDomainConfiguration['config']['story']['addNoFollowTags'] === 'true') {
            // Fetch the white listed domains from config and split to form array
            var whiteListedDomainsString = this.currentDomainConfiguration['config']['story']['whiteListedDomains'];
            var whiteListedDomains = [];
            if (whiteListedDomainsString !== null && whiteListedDomainsString !== undefined) {
                whiteListedDomains = whiteListedDomainsString.split(',');
            }
            else {
                whiteListedDomains = [];
            }
            const domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            const alldomains = localStorage.getItem(StaticDataService.domains_all);
            const currDomain = JSON.parse(alldomains).find(e => e.id == domainId);
            whiteListedDomains.push(currDomain.baseUrl.replace('http://', '').replace('https://', ''));
            // Stringify the json received
            var input_content = JSON.stringify(jso);
            // array to store the identified anchor tags
            var anchors = [];
            // split the json string to extract the valid anchor tags into anchors array
            anchors = input_content.split(/(<a[\s]+[^>]+>(?:.(?!\<\/a\>))*.<\/a>)/g);
            anchors = anchors.filter(e => (e.startsWith("\<a") && e.endsWith("\<\/a\>")));
            anchors.forEach(anchor => {
                var div = document.createElement('div');
                div.innerHTML = anchor;
                var ancUrl = div.firstChild.getAttribute("href");
                ancUrl = ancUrl !== null ? ancUrl.replace(/"/g, '').replace(/\\/g, '') : ancUrl;
                let hostName = '';
                try {
                    const { hostname } = new URL(ancUrl);
                    hostName = hostname;
                }
                catch (error) {
                    console.log('invalid url error');
                    hostName = ancUrl !== null ? ancUrl.replace('http://', '').replace('https://', '').replace(/"/g, '').replace(/\\/g, '') : ancUrl;
                }
                // var ancUrl1 = ancUrl.replace('http://','').replace('https://','').replace(/"/g,'').replace(/\\/g,'').split('.com')[0]+'.com';
                // If the receied url is not a whitelisted url, replace the anchor tag with no follow tag
                if (whiteListedDomains.indexOf(hostName) === -1) {
                    var anc = document.createElement('a');
                    anc.setAttribute("rel", "nofollow");
                    anc.setAttribute("href", ancUrl);
                    anc.setAttribute("target", "_blank");
                    anc.setAttribute("class", "manualbacklink");
                    // Create the text node for anchor element.
                    var link1 = document.createTextNode(div.firstChild.innerHTML);
                    // Append the text node to anchor element.
                    anc.appendChild(link1);
                    let strAnc = JSON.stringify(anc.outerHTML.replace(/&quot;/g, '').replace(/\\/g, "")).substring(1).slice(0, -1);
                    input_content = input_content.replace(anchor, strAnc);
                }
            });
            return JSON.parse(this.htmlSpecialCharToText(input_content));
        }
        else {
            return jso;
        }
    }
    htmlSpecialCharToText(text) {
        // const tevmbrgvr = '&nbsp;&amp;&quot;&lt;&gt;';
        const translate_re = /&(nbsp|amp|quot|lt|gt);/g;
        const translate = {
            'nbsp': ' ',
            'amp': '&',
            'quot': '\'',
            'lt': '<',
            'gt': '>'
        };
        return (text.replace(translate_re, (match, entity) => {
            return translate[entity];
        }));
    }
    isEmbedStripEnabled() {
        return (this.currentDomainConfiguration && this.currentDomainConfiguration['config']
            && this.currentDomainConfiguration['config']['story']
            && this.currentDomainConfiguration['config']['story']['stripEmbed'] === 'true');
    }
    uploadImage(imageData, allowLowQuality) {
        console.log("ALWAYS HERE");
        const fd = new FormData();
        fd.append('file', imageData, imageData.name);
        if (allowLowQuality) {
            fd.append('removeLowQualityRestriction', 'true');
        }
        return this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd);
    }
    deletePreviousImage(url) {
        const fd = new FormData();
        fd.set('url', url);
        return this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageDeleteEndPoint, fd);
    }
    checkForMetadataDuration(embedCode) {
        const div = document.createElement('DIV');
        div.innerHTML = embedCode;
        const childNode = div.getElementsByTagName('meta');
        if (this.isEmbedStripEnabled() && (embedCode.indexOf('cdn.jwplayer.com') > -1) && childNode && childNode.length > 0) {
            const a = Array.from(childNode).map(item => {
                const att = item.attributes;
                if (att[0].value === 'duration' && att[1].name === 'content') {
                    return att[1].value;
                }
                else {
                    return false;
                }
            }).filter(e => (e));
            if (a.length > 0) {
                const time = a[0];
                const t = time.replace('PT', '');
                const h = t.indexOf('H') > -1 ? (t.split('H')[0]) : false;
                const m = t.indexOf('M') > -1 ? (h ? t.split('H')[1].split('M')[0] : t.split('M')[0]) : false;
                const s = t.indexOf('S') > -1 ? (m ? t.split('M')[1].split('S')[0] : t.split('S')[0]) : false;
                const totalms = (h ? ((+h) * 3600000) : 0)
                    + (m ? ((+m) * 60000) : 0)
                    + (s ? ((+s) * 1000) : 0);
                return totalms;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    checkIfRestrictedCharactersArePresent(originalText, type) {
        const text = this.stripHtml(originalText);
        switch (type) {
            case 'headline':
                // return (/["(){}\[\]]/g).test(text);
                return (/["{}\[\]]/g).test(text);
            case 'summary':
                // return (/["']/g).test(text);
                return (/["]/g).test(text);
            case 'caption':
                // return (/[",!@#$%^&*<>?(){}\[\]]/g).test(text);
                return (/["!^*{}\[\]]/g).test(text);
            default:
                return false;
        }
    }
    stripHtml(html) {
        const tmp = document.createElement('DIV');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || '';
    }
    getUpdatedFilters(filters, type) {
        const isAuthorIdEnabled = !!(this.currentDomainConfiguration && this.currentDomainConfiguration['config']
            && this.currentDomainConfiguration['config']['story'] && this.currentDomainConfiguration['config']['story']['authorId']
            && this.currentDomainConfiguration['config']['story']['authorId'] === 'true');
        if (this.checkLocationFilterAdd(filters)) {
            filters.push({
                'filter_id': 'flags',
                'name': 'Location',
                'facet_name_meta': 'location',
                'facet_name': 'metadata.primaryLocation',
                'type': 'checkbox',
            });
        }
        if (isAuthorIdEnabled) {
            return filters.map(filter => {
                if (filter.filter_id === 'byline') {
                    return ({
                        'filter_id': 'byline',
                        'name': 'Byline',
                        'facet_name_meta': 'authorsList',
                        'facet_name': 'metadata.authorsList.id',
                        'type': 'checkboxKeyValue',
                        'isDataKeyValuePair': true
                    });
                }
                else {
                    return filter;
                }
            });
        }
        if (type === 'story' && this.isdomainConfig('story', 'segmentMetaEnabled') && this.checkSegmentFilterAdd(filters)) {
            filters.push({
                'filter_id': 'segment',
                'name': 'Segment',
                'facet_name_meta': 'segment',
                'facet_name': 'metadata.segment',
                'type': 'checkbox',
            });
        }
        return filters;
    }
    checkLocationFilterAdd(filters) {
        if (this.currentDomainConfiguration && this.currentDomainConfiguration['config']
            && this.currentDomainConfiguration['config']['story'] && this.currentDomainConfiguration['config']['story']['locationFilter']) {
            for (let filter of filters) {
                if (filter['facet_name_meta'] === 'location') {
                    return false;
                }
            }
            return true;
        }
        return false;
    }
    checkSegmentFilterAdd(filters) {
        for (let filter of filters) {
            if (filter['facet_name_meta'] === 'segment') {
                return false;
            }
        }
        return true;
    }
    getCurrentDomainConfig(callback) {
        const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
        const conf = localStorage.getItem(StaticDataService.domainsConfigLiteral);
        if (conf && domain) {
            callback(JSON.parse(conf)[domain]);
        }
        else {
            setTimeout(e => {
                this.getCurrentDomainConfig(callback);
            }, 100);
        }
    }
    // getTwitterEmbed(url) {
    //     return this.restService.http_get(StaticDataService.twitterEmbedUrl + url);
    // }
    // getInstagramEmbed(url) {
    //     return this.restService.http_get(StaticDataService.instagramEmbedUrl + url);
    // }
    getAutomaticEmbed(url) {
        // http://<host>/api/cms/story/embedcode?urlToEmbed=<url
        const base = this.config.get('product').baseUrl + '/api/cms/story/embedcode?urlToEmbed=';
        return this.restService.http_get(base + url);
    }
    runEmbedProcessor(embed, element) {
        if (embed.indexOf('https://www.instagram.com') > -1) {
            setTimeout(e => {
                window['instgrm'].Embeds.process();
            }, 500);
        }
        else if (embed.indexOf('https://twitter.com') > -1) {
            setTimeout(e => {
                window['twttr'].ready(function () {
                    window['twttr'].widgets.load();
                });
            }, 500);
        }
    }
    escToText(text) {
        // const tevbrgvr = '&nbsp;&amp;&quot;&lt;&gt;';
        const translate_re = /&(|\n|\");/g;
        const translate = {
            '\n': ' ',
            '\"': '"',
        };
        return (text.replace(translate_re, (match, entity) => {
            return translate[entity];
        }));
    }
    isdomainConfig(domainNode1, domainNode2) {
        return (this.currentDomainConfiguration && this.currentDomainConfiguration['config']
            && this.currentDomainConfiguration['config'][domainNode1] && this.currentDomainConfiguration['config'][domainNode1][domainNode2] === 'true');
    }
    makeRenderable(text) {
        return this.sanitizer.bypassSecurityTrustHtml(text);
    }
    isPinnedElementEnabled() {
        return (this.currentDomainConfiguration && this.currentDomainConfiguration['config']
            && this.currentDomainConfiguration['config']['liveblog'] && this.currentDomainConfiguration['config']['liveblog']['pinnedElements']
            && (Number(this.currentDomainConfiguration['config']['liveblog']['pinnedElements']) > 0))
            ? Number(this.currentDomainConfiguration['config']['liveblog']['pinnedElements']) : 0;
    }
    generateChartDatasetFromTable(tableData, chartConfig) {
        const div = document.createElement('DIV');
        div.innerHTML = tableData;
        const table = Array.from(div.getElementsByTagName('table')[0].children[0].children);
        switch (chartConfig.type) {
            case 'line':
            case 'bar':
                chartConfig.data.datasets = [];
                table.forEach((element, index) => {
                    const row = Array.from(element.children);
                    if (index === 0) {
                        chartConfig.data.labels = row.slice(1, row.length).map(e => e['innerText']);
                    }
                    else {
                        const dataset = JSON.parse(JSON.stringify(StaticDataService.LineChartdataset));
                        dataset.label = row[0]['innerText'];
                        dataset.data = row.slice(1, row.length).map(e => +e['innerText']);
                        dataset.backgroundColor = StaticDataService.chartColor[index - 1];
                        dataset.borderColor = StaticDataService.chartColor[index - 1];
                        chartConfig.data.datasets.push(dataset);
                    }
                });
                return chartConfig;
            case 'pie':
            case 'doughnut':
                chartConfig.data.datasets = [{
                        data: [],
                        backgroundColor: [],
                        borderColor: []
                    }];
                chartConfig.data.labels = [];
                table.forEach((element, index) => {
                    const row = Array.from(element.children);
                    chartConfig.data.labels.push(row[0]['innerText']);
                    chartConfig.data.datasets[0].data.push(+row[1]['innerText']);
                    chartConfig.data.datasets[0].backgroundColor.push(StaticDataService.chartColor[index - 1]);
                    chartConfig.data.datasets[0].borderColor.push(StaticDataService.chartColor[index - 1]);
                });
                return chartConfig;
            default: break;
        }
    }
    convertBase64ToBlob(Base64Image) {
        return fetch(Base64Image);
    }
    getDropDownSettings(ev, idField, textField) {
        if (typeof ev === 'boolean') {
            if (ev === false) {
                return {
                    singleSelection: false,
                    text: "Select",
                    selectAllText: 'Select All',
                    unSelectAllText: 'UnSelect All',
                    enableSearchFilter: true,
                    primaryKey: idField,
                    labelKey: textField,
                    noDataLabel: 'No Data Available',
                    itemsShowLimit: 4,
                    closeDropDownOnSelection: true,
                    maxHeight: 197
                };
            }
            else if (ev === true) {
                return {
                    singleSelection: true,
                    primaryKey: idField,
                    labelKey: textField,
                    noDataLabel: 'No Data Available',
                    itemsShowLimit: 4,
                    enableSearchFilter: false,
                    closeDropDownOnSelection: true,
                    maxHeight: 197
                };
            }
        }
    }
    formatDate(dateString) {
        const dateParts = dateString.split('-');
        const year = dateParts[0];
        const month = this.getMonthName(parseInt(dateParts[1], 10));
        const day = dateParts[2];
        return `${day}-${month}-${year}`;
    }
    getMonthName(month) {
        const monthNames = [
            'january',
            'february',
            'march',
            'april',
            'may',
            'june',
            'july',
            'august',
            'september',
            'october',
            'november',
            'december'
        ];
        return monthNames[month - 1];
    }
    getDateWithoutTime(seconds) {
        if (seconds) {
            const date = new Date(seconds);
            return '' + this.monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
        }
        else {
            return 'not present';
        }
    }
    getDate(datestring) {
        if (datestring) {
            if (typeof datestring === 'string') {
                const dt = new Date(datestring.replace('+0000', 'Z'));
                return this.getDateWithoutTime(Math.round(dt.getTime()));
            }
            else {
                return this.getDateWithoutTime(datestring);
            }
        }
        else {
            return '';
        }
    }
    removeAllFormatLinks(editor, cardData) {
        if (cardData.type === 'paragraph') {
            let edata = editor.getData();
            let regex = new RegExp(/<a.*?>([^>]*)<\/a>/, 'g');
            let m;
            let words = [];
            do {
                m = regex.exec(edata);
                if (m) {
                    words.push(m[1]);
                }
            } while (m);
            let replaced_text = edata;
            for (let word of words) {
                let replaceThis = '<a.*?>' + word + '<\/a>';
                let regexReplace = new RegExp(`${replaceThis}`);
                let l = regexReplace.exec(replaced_text);
                replaced_text = replaced_text.replace(regexReplace, word);
            }
            editor.setData(replaced_text);
        }
    }
    replaceTextWithHyperLink(paraEditor, positions, word, listOfWords, callback) {
        for (let i of positions) {
            paraEditor.deleteText(i, word.length);
            paraEditor.insertText(i, word, 'link', this.currentDomainUrl + listOfWords[word]);
        }
        callback();
    }
    findOccurenceInPara(source, find) {
        if (!source) {
            return [];
        }
        if (!find) {
            return source.split('').map(function (_, i) { return i; });
        }
        let result = [];
        let i = 0;
        let count = 0;
        find = ' ' + find;
        while (i < source.length) {
            if (i == 0) {
                find = find.substring(1);
                if (source.substring(i, i + find.length) === find) {
                    result.push(i);
                    i += find.length;
                }
                else {
                    i++;
                }
                find = ' ' + find;
            }
            else {
                if (source.substring(i, i + find.length) === find) {
                    result.push(i + 1);
                    i += find.length;
                }
                else {
                    i++;
                }
            }
        }
        return result;
    }
    googleAnalytics(eventCategory, eventAction, eventLabel, eventValue) {
        this.gaService.gaEventView(eventCategory, eventAction, eventLabel, eventValue);
    }
    checkingHyperlinkValid(editor) {
        if (editor && editor.model) {
            const doc = editor.model.document;
            const selection = doc.selection;
            const range = selection.getFirstRange();
            let selectedWord;
            for (const item of range.getItems()) {
                selectedWord = item.data;
            }
            let docStr = (JSON.stringify(doc));
            if (JSON.parse(docStr)['differ']['_cachedChanges'][0]['attributeKey'] === 'linkHref') {
                let hrefUrl = this.extractHrefUrl(editor);
                if (hrefUrl !== undefined && hrefUrl !== null) {
                    const validLink = this.checkUrlValidate(hrefUrl, editor);
                    if (validLink) {
                        this.restService.http_get(this.config.get('product').utilUrl + '/api/cms/validate/link/?url=' + hrefUrl)
                            .subscribe((response) => {
                            if (response.statusCode === 200) {
                                console.log("response", response);
                            }
                            else {
                                setTimeout(e4 => {
                                    if (editor) {
                                        editor.model.change(writer => {
                                            writer.clearAttributes(editor.model.document.selection['_selection']['_ranges'][0]);
                                        });
                                    }
                                }, 1000);
                                this.snotify.error('Link is invalid', '', this.getConfig(false));
                            }
                        }, error => {
                            setTimeout(e4 => {
                                if (editor) {
                                    editor.model.change(writer => {
                                        writer.clearAttributes(editor.model.document.selection['_selection']['_ranges'][0]);
                                    });
                                }
                            }, 1000);
                            this.snotify.error('Link is invalid', '', this.getConfig(false));
                        });
                    }
                }
            }
            else {
                return true;
            }
        }
    }
    checkUrlValidate(url, editor) {
        var urlValid = /[a-z0-9-]*\.?[a-z0-9-]+\.[a-z0-9-]+\.?[a-z0-9-]+(\/[^<>]*)?$/;
        if (urlValid.test(url) === false) {
            this.snotify.info('Please enter valid URL', '', this.getConfig(false));
            setTimeout(e4 => {
                if (editor) {
                    editor.model.change(writer => {
                        writer.clearAttributes(editor.model.document.selection['_selection']['_ranges'][0]);
                    });
                }
            }, 1000);
        }
        else if (!url.startsWith('https')) {
            this.snotify.error('Link is invalid,link should be start with https.Please enter valid link.', '', this.getConfig(false));
            setTimeout(e4 => {
                if (editor) {
                    editor.model.change(writer => {
                        writer.clearAttributes(editor.model.document.selection['_selection']['_ranges'][0]);
                    });
                }
            }, 1000);
        }
        return urlValid.test(url) && url.startsWith('https');
    }
    extractHrefUrl(editor) {
        if (editor) {
            const doc = editor.model.document;
            const selection = doc.selection;
            const range = selection.getFirstRange();
            let docStr = (JSON.stringify(doc));
            return JSON.parse(docStr)['differ']['_cachedChanges'][0]['attributeNewValue'];
        }
    }
    findInvalidLinkWord(editor) {
        let edata = editor.getData();
        let regex = new RegExp(/<a.*?href="(.*?)".*?>([^>]*)<\/a>/, 'g');
        let m;
        let words = [];
        do {
            m = regex.exec(edata);
            if (m) {
                const href = m[1];
                const linkText = m[2];
                let obj = { linkText, href };
                words.push(obj);
            }
        } while (m);
        return words;
    }
}
SharedDataService.defaultNotificationData = {
    'id': null,
    'title': '',
    'description': '',
    'storyUrl': '',
    'imageUrl': '',
    'storyId': '',
    'devices': [],
    'deviceType': '',
    'campaignMappingId': '',
    'notificationTypeId': '',
    'licenseCode': ''
};
